import { useEffect } from "react";

const TARGET_URL = "https://petsas-moto.car.gr/bikes/";

// Catalog2 = εξωτερικός κατάλογος μεταχειρισμένων στο car.gr.
// Όταν κάποιος μπει στη /catalog2, μεταφέρεται αυτόματα στο εξωτερικό link.
// Αν για κάποιο λόγο αργήσει το redirect, βλέπει manual link.
export default function Catalog2() {
  useEffect(() => {
    window.location.replace(TARGET_URL);
  }, []);

  return (
    <div data-testid="catalog2-redirect" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <p className="text-overline mb-4">Μεταχειρισμένες</p>
        <h1 className="font-display font-black uppercase text-3xl md:text-4xl tracking-tight">
          Μεταφορά στο <span className="text-[#E50000]">car.gr</span>...
        </h1>
        <p className="mt-4 text-white/60 text-sm">
          Αν δεν ανακατευθυνθείς αυτόματα, κάνε κλικ στο κουμπί.
        </p>
        <a
          href={TARGET_URL}
          data-testid="catalog2-manual-link"
          className="btn-primary text-xs mt-8 inline-flex"
        >
          Δες όλες τις μεταχειρισμένες
        </a>
      </div>
    </div>
  );
}
